import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {ApplicationLogsRequest, Log} from "leia-api";
import {environment} from "../../environments/environment";
import {FacadeService} from "../shared/service-facade/facade.service";
import {NGXLogger} from "ngx-logger";
import {CoreService} from '../shared/services/core.service';
import {UtilitiesService} from "../shared/services/utilities.service";
import {BASK_BRAND_ID, PAGE_BREAK_PATH} from "../shared/constants";
import {Title} from "@angular/platform-browser";
import {CustomFavicon} from "../core/favicon.config";
import {NgxFaviconService} from "ngx-favicon";
import StatusEnum = ApplicationLogsRequest.StatusEnum;
//const mParticle = require("@mparticle/web-sdk");

@Component({
  selector: 'app-product-brand-selection',
  templateUrl: './set-product.component.html',
  styleUrls: ['./set-product.component.css']
})
export class SetProductComponent implements OnInit {
  utm: string | null = null;
  isBankingCenter : string = "false";

  constructor(private route: ActivatedRoute,
              private facadeService: FacadeService,
              private coreService: CoreService,
              private logger: NGXLogger,
              private utils: UtilitiesService,
              private titleService : Title,
              private ngxFaviconService: NgxFaviconService<CustomFavicon>) {
  }

  ngOnInit() {
    if(this.route.snapshot.queryParamMap.get('bankingCenter') !== null) this.isBankingCenter = this.route.snapshot.queryParamMap.get('bankingCenter')!.trim();
  }

  ngAfterContentInit() {
    this.createSession();
  }

  createSession() {
    const lowerCaseParams = this.toLower(this.route.snapshot.queryParams);

    this.utm = lowerCaseParams['utm'];
    this.logger.log(`url: ${location.href}\tutm: ${this.utm}`);

    this.setProduct();
  }

  //comment mParticle, CDP scripts are live, remove the code later
  /**
   * Sets the mParticle Key to the relevant instance based on the product
   */
  //  mParticleDataInit(mParticleKey: string): void {
  //   let mParticleConfig = {
  //     isDevelopmentMode: !environment.production,
  //     useCookieStorage: true,
  //     identityCallback: function({result}: { result: any }) {
  //       // Do something once an identity call has been made.
  //       // For more information, see https://docs.mparticle.com/developers/sdk/web/idsync/#sdk-initialization-and-identify
  //       console.log(result);
  //     },
  //   };
  //   mParticle.default.init(mParticleKey, mParticleConfig);
  // }

  /**
   * Sets the GTM Script to the relevant instance based on the product
   */
  gtmScriptInit(brandId: number, productUID: string) {
    const gtmScript = document.createElement('script');
    const gtmCode = brandId === BASK_BRAND_ID ? 'GTM-M33GZ85' : 'GTM-56JVTQQ';
    const sessionId = this.facadeService.getSessionId();
    const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','mp_data_layer','${gtmCode}'); if(mp_data_layer) mp_data_layer.push({'productUID': '${productUID}', 'transactionid': '${sessionId}'})`;
    gtmScript.type = 'text/javascript';
    gtmScript.innerHTML = script;
    document.head.appendChild(gtmScript);
  }

  /**
   * Sets the product information for the product that was specified in the query string
   * @param product
   */
  setProduct() {
    let log = new Log();
    log.source = "BB8";
    log.timestamp = new Date().toISOString();

    const product = this.facadeService.product;
    if (product != undefined) {
      this.titleService.setTitle(product.brandName);

      if(product.brandId === BASK_BRAND_ID) this.ngxFaviconService.setCustomFavicon(CustomFavicon.FAVICON_BASK);
      else this.ngxFaviconService.setCustomFavicon(CustomFavicon.FAVICON_TCB);

      //comment mParticle, CDP scripts are live, remove the code later
      // if(!mParticle.default.isInitialized()) {
      //   if(product.brandId === BASK_BRAND_ID) this.mParticleDataInit(environment.BaskmParticleKey);
      //   else this.mParticleDataInit(environment.mParticleKey);
      //   this.gtmScriptInit(product.brandId, product.productUID);
      // }
      const consentRejected = document.cookie.split(';').some(c => c.trim().startsWith('consentRejected='));
      if (!consentRejected) {
        this.gtmScriptInit(product.brandId, product.productUID);
      }

      this.facadeService.addStorageItem("isBankingCenter", this.isBankingCenter);

      let alloyWorkflowId : string = "";
      if (product.alloyWorkflowId) alloyWorkflowId = product.alloyWorkflowId.toString();
      this.facadeService.addStorageItem("alloyWorkflowId", alloyWorkflowId);

      // navigate to the root to enter the wizard/workflow
      this.navigateToTarget(`/${PAGE_BREAK_PATH}`);
    } else {
      let log = this.utils.createLog("BB8", "Product detail not loaded.");
      this.facadeService.handleInternalError(null, StatusEnum.Rejected, [log]);
    }
  }

  /**
   * navigates to a target path
   * @param targetPath
   */
  navigateToTarget(targetPath: string) {
    this.coreService.navigate(targetPath);
  }

  /**
   * Converts a list of parameters to be all lower case to make the checks case insensitive
   * @param params
   */
  toLower(params: Params): Params {
    const lowerParams: Params = {};
    for (const key in params) {
      lowerParams[key.toLowerCase()] = params[key];
    }
    return lowerParams;
  }
}
